export default __webpack_public_path__ + "static/media/autopilot-poster.6e5f4cb0.png";